import { SnapshotEventMail } from "@/modules/snapshots/businessReports.types";

export interface NoteFormData {
  title: string;
  message: string;
  is_default: boolean;
}

export const toFormData = (note: SnapshotEventMail): NoteFormData => ({
  title: note.title,
  message: note.message,
  is_default: note.is_default,
});

export const EMPTY_FORM: NoteFormData = {
  title: "",
  message: "",
  is_default: false,
};
